// TODO import 'babel-polyfill'
import React from 'react';
import { render } from 'react-dom';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import App from './components/App/App';
import { Provider } from "react-redux";
import store from "./redux/Store";
import ReactGA from 'react-ga';

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');

const history = createBrowserHistory();
history.listen(location => {
    ReactGA.set({ page: location.pathname }); // Update the user's current page
    ReactGA.pageview(location.pathname); // Record a pageview for the given page
});


if (process.env.NODE_ENV === 'production') {
    const trackingId = process.env.REACT_APP_GA_ID;
    ReactGA.initialize(trackingId);
} else {
    ReactGA.initialize('foo', { testMode: true, debug: true });
}


render(
    <Provider store={store}>
        <Router basename={baseUrl} history={history} >
            <App />
        </Router>
    </Provider>,    
    document.getElementById('root'),
);




// WEBPACK FOOTER //
// ./src/index.js